export const NoData = (props: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return <div className={props.className}>{props.children || 'No data'}</div>;
};
